export default {
  title_developers: 'Toți dezvoltatorii',
  breadcrumbs: {
    home: 'Acasă',
    developers: 'Dezvoltatori'
  },
  logo_alt: 'Logo dezvoltator',
  banner_alt: 'Banner dezvoltator',
  gallery_image_alt: 'Imagine galerie',
  founded: 'Fondat',
  residential_complexes: 'Complexuri rezidențiale',
  buildings: 'Clădiri',
  properties: 'Proprietăți',
  no_available: 'Niciun dezvoltator disponibil',
  gallery: 'Galerie foto',
  video: 'Video',
  contacts: 'Contacte',
  residential_complexes_from: 'Complexuri rezidențiale de la {name}',
  properties_from: 'Proprietăți de la {name}',
  tabs: {
    base: 'General',
    media: 'Media'
  },
  fields: {
    name: 'Nume',
    founded_year: 'Anul fondării',
    website: 'Website',
    email: 'Email',
    phone: 'Telefon',
    country: 'Țară',
    description_html: 'Descriere (HTML)',
    project_types: 'Tipuri de proiecte',
    locations: 'Locații'
  },
  buttons: {
    more: 'Detalii',
    pagination: {
      prev: 'Înapoi',
      next: 'Înainte'
    }
  }
}
